// SPDX-License-Identifier: AGPL-3.0-or-later

import LocalUserSpamOverride from '@app/features/moderation/state/LocalUserSpamOverride';
import {CheckboxItem} from '@app/features/ui/action_menu/ContextMenu';
import type {User} from '@app/features/user/models/User';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface SpammerOverrideMenuItemsProps {
	user: User;
	developerMode: boolean;
}
export function shouldShowSpammerOverrideMenuItems(params: {user: User; developerMode: boolean}): boolean {
	return params.developerMode;
}
export const SpammerOverrideMenuItems: React.FC<SpammerOverrideMenuItemsProps> = observer(({user, developerMode}) => {
	const {t} = useLingui();
	const isServerSpammer = LocalUserSpamOverride.isServerSpammer(user.flags);
	const isLocalSpammer = LocalUserSpamOverride.isLocallyMarkedSpammer(user.id);
	const isLocalNotSpammer = LocalUserSpamOverride.isLocallyMarkedNotSpammer(user.id);
	if (!shouldShowSpammerOverrideMenuItems({user, developerMode})) {
		return null;
	}
	return (
		<>
			<CheckboxItem
				checked={isLocalSpammer}
				onCheckedChange={(checked) => {
					if (checked) {
						LocalUserSpamOverride.markAsSpammer(user.id);
						return;
					}
					LocalUserSpamOverride.clearOverride(user.id);
				}}
				danger
			>
				{t`Locally Mark as Spammer`}
			</CheckboxItem>
			{isServerSpammer && (
				<CheckboxItem
					checked={isLocalNotSpammer}
					onCheckedChange={(checked) => {
						if (checked) {
							LocalUserSpamOverride.markAsNotSpammer(user.id);
							return;
						}
						LocalUserSpamOverride.clearOverride(user.id);
					}}
				>
					{t`Ignore Server Spammer Flag`}
				</CheckboxItem>
			)}
		</>
	);
});
